export default __webpack_public_path__ + "static/media/excel.f7ad5380.png";